module.exports = __webpack_public_path__ + "2945c1a92b693f9b5ea195aaa4517788.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/home-slide-2.webp
// module id = 1787
// module chunks = 0